module.exports = __webpack_public_path__ + "static/media/profile-details-screenshot.56e8f802.png";